// eslint-disable-next-line import/no-extraneous-dependencies
import Vue from 'vue';
import { Helpers } from '@bode-canada/core';

const INCORRECT_TYPE_OF_STATE_ERROR = 'State must be an object';

class ReactiveState {
  #initialStateValue = {};
  #value = {};

  constructor(initialStateValue) {
    this.#initialStateValue = ReactiveState.#getObservableObject(initialStateValue);
    this.#value = ReactiveState.#getObservableObject(initialStateValue);
  }

  get value() {
    return this.#value;
  }

  get initialState() {
    return this.#initialStateValue;
  }

  patch(partialState) {
    ReactiveState.#patchToObservableObject(this.#value, partialState);
  }

  patchInitialValue(partialInitialValue) {
    ReactiveState.#patchToObservableObject(this.#initialStateValue, partialInitialValue);
  }

  resetPartially(fields) {
    fields.forEach((field) => {
      this.#value[field] = this.#initialStateValue[field];
    });
  }

  reset() {
    this.patch({ ...this.#initialStateValue });
  }

  static #checkStateIsObject(value) {
    if (!Helpers.ObjectHelper.isObject(value)) {
      this.#throwStateTypeError();
    }
  }

  static #throwStateTypeError() {
    throw new Error(INCORRECT_TYPE_OF_STATE_ERROR);
  }

  static #getObservableObject(object) {
    ReactiveState.#checkStateIsObject(object);

    const observableObject = Vue.observable({ ...object });

    Object.preventExtensions(observableObject);

    return observableObject;
  }

  static #patchToObservableObject(observableObject, partialStateValue) {
    ReactiveState.#checkStateIsObject(partialStateValue);

    Object.entries(partialStateValue)
      .filter(([field]) => observableObject.hasOwnProperty.call(observableObject, field))
      .forEach(([field, value]) => {
        // eslint-disable-next-line no-param-reassign
        observableObject[field] = value;
      });
  }
}

export default ReactiveState;
